import React from "react";
import "./Loader.css";
import loadingLogo from "../../assets/images/logogc-nobg.png";

function Loader() {
  return (
    <div className="loader">
      <img
        src={loadingLogo}
        alt="Loading Logo"
        className="loader-logo"
      />
    </div>
  );
}

export default Loader;
